import React, { useState } from "react";
import {
  Navbar,
  Nav,
  NavDropdown,
  Container,
  Form,
  FormControl,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";
import top from "../../assests/top.png";
import NavMobile from "./NavMobile";

const Header3 = () => {
  const [show, setShow] = useState(false);
  const [searchText, setSearchText] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();

  // Handle search on Enter key press
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    if (searchText && e.key === "Enter") {
      // Navigate to the search results page with the query as a URL parameter
      navigate(`/search/${searchText}`);
      setSearchText("");
    }
  };

  // Handle key press for "Enter" key to trigger form submission
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e); // Call the handleSubmit function on Enter key
    }
  };
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Ensures smooth scrolling
    });
    setShow(false);
  };

  return (
    <>
      <Navbar
        expand="xl"
        bg="white"
        variant="white"
        className="jab_navbar3_common_bgcolor  border-bottom "
      >
        <Container>
          <Navbar.Toggle onClick={handleShow}  />
          <Form className="d-flex mobile_searchbar d-xl-none d-block" onSubmit={handleSubmit}>
         
         <FormControl
           type="search"
           placeholder="Search"
           value={searchText}
           onChange={(e) => setSearchText(e.target.value)}
           onKeyPress={handleKeyPress} // Handle Enter key press
           className="jab_searchbar"
           aria-label="Search"
         />
       </Form>
          <Navbar.Collapse id="basic-navbar-nav" className="d-xl-block d-none">
            <Nav className="me-auto">
              <Nav.Link
                to="/"
                as={Link}
                className="mx-2 "
                onClick={handleScrollToTop}
              >
                Home
              </Nav.Link>
              <Nav.Link
                to="/about"
                as={Link}
                className="mx-2 "
                onClick={handleScrollToTop}
              >
                About
              </Nav.Link>

              <Nav.Link
                to="/information/article-processing-charges/0-general-information-on-article-processing-charges-apc"
                as={Link}
                className="mx-2 "
                onClick={handleScrollToTop}
              >
                Article Processing Charges
              </Nav.Link>

              <NavDropdown
                title="Archives"
                id="basic-nav-dropdown-resources"
                className="mx-2"
              >
                <NavDropdown.Item
                  to="/current-issue"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Current Issue
                </NavDropdown.Item>
                <NavDropdown.Item
                  to="/issue-archive"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  All Archive
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown
                title="For Authors"
                id="basic-nav-dropdown-forauthor"
                className="mx-2"
              >
                <NavDropdown.Item
                  to="/information/for-authors-2/0-information-for-authors"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Information For Authors
                </NavDropdown.Item>
                <NavDropdown.Item
                  to="/information/for-authors-2/1-useful-resources-for-authors"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Useful Resources for Authors
                </NavDropdown.Item>
                <NavDropdown.Item
                  to="/information/for-authors-2/2-manuscript-submission-amp-instructions-for-authors"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Manuscript Submission & Instructions for Authors
                </NavDropdown.Item>
                <NavDropdown.Item
                  to="/information/for-authors-2/5-funding-of-apcs-and-bpcs"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Funding of APCs and BPCs
                </NavDropdown.Item>
                <NavDropdown.Item
                  to="/information/for-authors-2/10-general-peer-review-and-editorial-procedures"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  General Peer-Review and Editorial Procedures
                </NavDropdown.Item>

                <NavDropdown.Item
                  to="/information/for-authors-2/11-editorial-decision-and-revision"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Editorial Decision and Revision
                </NavDropdown.Item>

                <NavDropdown.Item
                  to="/information/for-authors-2/12-long-term-archiving"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Long Term Archiving
                </NavDropdown.Item>
                <NavDropdown.Item
                  to="/information/for-authors-2/13-bsp-guidelines-on-artificial-intelligence-and-authorship-"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  BSP Guidelines on Artifical Intelligence and Authorship
                </NavDropdown.Item>

                <NavDropdown.Item
                  to="/journal-information"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Journal Information
                </NavDropdown.Item>

                <NavDropdown.Item
                  to="/information/editorial-criteria-and-processes/0--how-to-submit-an-article-"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                 Editorial Criteria and Processes
                </NavDropdown.Item>
              </NavDropdown>
      

              <NavDropdown
                title="For Reviewers"
                id="basic-nav-dropdown-forreviews"
                className="mx-2"
              >
                <NavDropdown.Item
                  to="/for-reviewers/0-benefits-for-peer-reviewers"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Benifits for Peer-Reviewers
                </NavDropdown.Item>
                <NavDropdown.Item
                  to="/for-reviewers/1-invitation-to-join-our-peer-reviewer-database"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Invitation to Join our Peer-Reviewer Database
                </NavDropdown.Item>

                <NavDropdown.Item
                  to="/for-reviewers/2-invitation-to-review"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Invitation to Review
                </NavDropdown.Item>
                <NavDropdown.Item
                  to="/for-reviewers/3-potential-conflicts-of-interests"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Potential Conflicts of Interests
                </NavDropdown.Item>
                <NavDropdown.Item
                  to="/for-reviewers/4-confidentiality-and-anonymity"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Confidentiality and Anonymity
                </NavDropdown.Item>
                <NavDropdown.Item
                  to="/for-reviewers/5-timely-review-reports"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Timely Review Reports
                </NavDropdown.Item>
                <NavDropdown.Item
                  to="/for-reviewers/6-rating-the-manuscript"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Rating the Manuscipt
                </NavDropdown.Item>
                <NavDropdown.Item
                  to="/for-reviewers/7-overall-recommendation"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Overall Recommendation
                </NavDropdown.Item>
                <NavDropdown.Item
                  to="/for-reviewers/8-peer-review-report"
                  as={Link}
                  onClick={handleScrollToTop}
                >
                  Peer-review Report
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>

            <Nav>
              {/* Search Bar */}
              <Form className="d-flex my-1 mx-1" onSubmit={handleSubmit}>
         
                <FormControl
                  type="search"
                  placeholder="Search"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyPress={handleKeyPress} // Handle Enter key press
                  className="py-0 jab_searchbar"
                  aria-label="Search"
                />
              </Form>

              <Nav.Link
                to="/submit-article"
                as={Link}
                className=""
                onClick={handleScrollToTop}
              >
                Submit article
                <img src={top} alt="icon" width={15} className="mx-2" />
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Uncomment if implementing a mobile-specific navigation */}
    
      <NavMobile
        show={show}
        handleClose={handleClose}
        handleScrollToTop={handleScrollToTop}
      />
    </>
  );
};

export default Header3;
